<template>
  <div>
    <b-modal
      ref="modal-settings-entity-group"
      :title="$t('Areas by module') | capitalize"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      size="lg"
    >
      <b-table
      ref="ref-table-areas-module"
      :per-page="paginate.perPage"
      :current-page="paginate.currentPage"
      sticky-header="50vh"
      small
      class="position-relative"
      :busy.sync="isBusy"
      :items="myProvider"
      :fields="showFields"
      primary-key="id"
      >
        <template #table-busy>
          <b-skeleton-table
            :headers="fields"
            :rows="paginate.perPage"
            :columns="fields.length"
            :table-props="{ bordered: true, striped: true }"
          />
        </template>
        <template #cell(operation)="data">
          <div v-if="data.item.other_module == null">
            <div v-if="data.item.type == 'IN'" class="d-flex justify-content-center">
              <b-badge variant="light-success">{{data.item.area}}</b-badge>
              <div>
                <feather-icon
                icon="ArrowRightCircleIcon"
                class="text-warning mx-1"
                size="18"
                />
              </div>
              <p class="m-0">{{data.item.module}}</p>              
            </div>
            <div v-else class="d-flex justify-content-center">
              <p class="m-0">{{data.item.module}}</p>  
              <div>
                <feather-icon
                icon="ArrowRightCircleIcon"
                class="text-warning mx-1"
                size="18"
                />
              </div>
              <b-badge variant="light-danger">{{data.item.area}}</b-badge>              
            </div>
          </div>
          <div v-else class="d-flex">
            <p class="m-0" v-if="data.item.type == 'IN'">{{data.item.other_module}}</p>
            <p class="m-0" v-else>{{data.item.module}}</p>
            <div>
              <feather-icon
              icon="ArrowRightCircleIcon"
              class="text-warning mx-1"
              size="18"
              />
            </div>
            <b-badge :variant="data.item.type == 'IN' ? 'light-success' : 'light-danger'">{{data.item.area}}</b-badge>
            <div>
              <feather-icon
              icon="ArrowRightCircleIcon"
              class="text-warning mx-1"
              size="18"
              />
            </div>
            <p class="m-0" v-if="data.item.type == 'IN'">{{data.item.module}}</p>
            <p class="m-0" v-else>{{data.item.other_module}}</p>
          </div>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import modalMixin from "@/mixins/modal";
import AreasModuleService from "@/views/settings/views/areas-module/service/areas-module.service.js";
import Fields from "@/views/settings/views/areas-module/data/tracking.fields.js";
import { VueAutosuggest } from "vue-autosuggest";
export default {
  mixins: [modalMixin],
  components: {
    VueAutosuggest,
  },
  props: {
    moduleId: Number
  },
  data() {
    return {
      areas: [],
      area: {},
      areasSelected: [],
      initialAreaIds: [],
      trackingFields: Fields,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "SEARCH...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      isBusy:false,
    };
  },
  async mounted() {
    this.toggleModal("modal-settings-entity-group");
  },
  computed: {
    showFields() {
      return Fields.map((item) => ({ ...item, label: this.$t(item.label) }));
    },

    fields() {
      return Fields.map((element) => ({
        ...element,
        label: this.$t(element.label),
      }));
    },
  },
  methods: {
    async myProvider(){
      const params = {
        module_id: this.moduleId
      }
      const { data } = await AreasModuleService.getTracking(params);
      return data
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>